import BaseApiRequest from "./BaseApiRequest";
import { GETTING_STARTED_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GettingStartedRequest extends BaseApiRequest {
  method = METHOD.HTTP.PUT;

  body = {
    branch: "",
    isCardRequired: false,
  };

  constructor(apiBody) {
    super();
    this.body = apiBody;
  }

  getMethod = () => this.method;

  getUrl = () => {
    return getCurrentUserParameters(GETTING_STARTED_URL);
  };

  getBody = () => this.body;
}
